<template>
  <div class="min-h-screen bg-base-200 py-16 px-4 sm:px-6 lg:px-8">
    <div class="max-w-5xl mx-auto animate-fade-in-up">
      
      <div class="text-center mb-16 space-y-4">
        <h1 class="text-4xl md:text-5xl font-extrabold text-base-content">Partner With Aanza</h1>
        <p class="text-xl text-base-content/70 max-w-2xl mx-auto">
          Join our ecosystem of modern restaurants and tech innovators. Let's revolutionize dining experiences together.
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div class="card bg-base-100 shadow-xl hover:-translate-y-2 transition-transform duration-300">
          <div class="card-body items-center text-center">
            <div class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center text-primary mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
            </div>
            <h2 class="card-title text-xl text-base-content">Boost Efficiency</h2>
            <p class="text-base-content/70">Integrate our QR order management system into your operations to reduce staff dependency and serve more customers faster.</p>
          </div>
        </div>

        <div class="card bg-base-100 shadow-xl hover:-translate-y-2 transition-transform duration-300">
          <div class="card-body items-center text-center">
            <div class="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center text-secondary mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            </div>
            <h2 class="card-title text-xl text-base-content">Increase Sales</h2>
            <p class="text-base-content/70">Beautiful, interactive digital menus with high-quality images lead to higher order values and better customer retention.</p>
          </div>
        </div>

        <div class="card bg-base-100 shadow-xl hover:-translate-y-2 transition-transform duration-300">
          <div class="card-body items-center text-center">
            <div class="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center text-accent mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
            </div>
            <h2 class="card-title text-xl text-base-content">Tech Integrations</h2>
            <p class="text-base-content/70">Connect your existing POS, stock, and employee management systems smoothly with our powerful APIs.</p>
          </div>
        </div>
      </div>

      <div class="mt-16 bg-base-100 rounded-3xl p-8 md:p-12 shadow-lg text-center">
        <h3 class="text-3xl font-bold mb-4">Ready to get started?</h3>
        <p class="text-xl text-base-content/70 mb-8 max-w-2xl mx-auto">Fill out our partner inquiry form and our team will get back to you within 24 hours.</p>
        <button class="btn btn-primary btn-lg hover:scale-105 transition-transform">Become a Partner</button>
      </div>

    </div>
  </div>
</template>

<style scoped>
.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
